export default "__VITE_ASSET__JKl3NMiS__"